import { proxy } from 'valtio';
import { GuidePost } from '@oldDashboard/legacyModels/guidePost.model';	
import { Launches } from '@oldDashboard/legacyModels/launches.model';
import { TimePeriods } from '@models/timePeriods.model';
import { LaunchesDate } from '@oldDashboard/legacyModels/launchesDate.model';
import { FileSummary } from '@oldDashboard/legacyModels/fileSummary.model';
import { EngagementTeam } from '@oldDashboard/legacyModels/engagementTeam.model';
import { LaunchKeyDates } from '@oldDashboard/legacyModels/launchKeyDates.model';
import { LastTermDistribution } from '@oldDashboard/legacyModels/lastTermDistribution.model';
import { RecommendedAction } from '@oldDashboard/legacyModels/recommendedAction.model';
import { LeadingIndicator } from '@oldDashboard/legacyModels/leadingIndicador.model';
import { MotivationPrinciple } from '@oldDashboard/legacyModels/motivationPrinciple.model';
import { ListSizeOverTime } from '@oldDashboard/legacyModels/listSizeOverTime.model';
import { EngagementData } from '@oldDashboard/legacyModels/engagementData.model';
import { TotalGpSummary } from '@oldDashboard/legacyModels/totalGpSummary.model';
import { CumulativeInvoice } from '@oldDashboard/legacyModels/cumulativeInvoice';
import { ConstituentLevelConversionData } from '@oldDashboard/legacyModels/constituentLevelConversionData.model';

interface IDashboardClientState {
    launches: Launches[],
	timePeriods: TimePeriods[]
	timePeriodSelected: string,
	launchSelected: string,
	constituentsConversions: ConstituentLevelConversionData,
	fileSummaryData: FileSummary[],
	launchDates: LaunchesDate[]
	topGuideposts: GuidePost[],
	listSizeOvertime: ListSizeOverTime[],
	lastTermDistribution:LastTermDistribution,
	topPerformingNetwork: [],
	totalStudents: string,
	launchGoal: string,
	recommendedActions: RecommendedAction,
	conversionJourneys: [],
	searching: boolean,
	launchKeydates: LaunchKeyDates,
	totalGpSummary: TotalGpSummary,
	engagementTeam: EngagementTeam,
	leadersIndicators:LeadingIndicator,
	runningIdeas: GuidePost[],
	scheduledIdeas: GuidePost[],
	motivationPrinciples: MotivationPrinciple[],
	engagementData: EngagementData,
	cumulativeInvoice: CumulativeInvoice
}

class DashboardStore {
  // Initial state setup
  state = proxy<IDashboardClientState>({
    launches: [],
	timePeriods: [],
	timePeriodSelected: "1",
	launchSelected: "",
	constituentsConversions: new ConstituentLevelConversionData,
	fileSummaryData:[],
	launchDates: [],
	topGuideposts: [],
	listSizeOvertime: [],
	lastTermDistribution:{data: [],header: []},
	topPerformingNetwork: [],
	totalStudents: "N/A",
	launchGoal: "-",
	recommendedActions: {data: [],header: []},
	conversionJourneys: [],
	searching: false,
	launchKeydates: {data: [],header: []},
	totalGpSummary: {totalActivated: "0", totalAwaiting:"0"},
	engagementTeam: {engagementManager: "", engagementManagerEmail:"0", enterprisePartnershipManager: "", enterprisePartnershipManagerEmail:""}, 
	leadersIndicators:new LeadingIndicator ,
	runningIdeas: [],
	scheduledIdeas: [],
	motivationPrinciples: [],
	engagementData: {engagements: "0", clicksOutbound: "0"},
	cumulativeInvoice: new CumulativeInvoice()
  });

}

export const dashboardState = proxy(new DashboardStore());